<script setup lang="ts">
/** @todo temporary solution to prevent hydration mismatch issue */
const ariaId = useId();

const props = defineProps({
	name: {
		type: String,
		default: "Color"
	},
	hex: {
		type: String,
		default: "#ffffff"
	},
	modelValue: {
		type: Boolean,
		default: false
	}
});
defineEmits(["update:modelValue"]);

const backgroundStyles = computed(() => {
	const styles = {
		border: "",
		backgroundColor: `#${props.hex.replace(/^#/, "")}`
	};

	if (styles.backgroundColor.toLowerCase() === "#ffffff") {
		styles.border = "1px solid #e7e7ec";
	}

	return styles;
});
</script>

<template>
	<VTooltip
		:triggers="['hover', 'click']"
		placement="top"
		:distance="8"
		:aria-id="ariaId"
	>
		<label>
			<div
				class="w-[28px] h-[28px] flex justify-center items-center rounded-full border-2 border-transparent cursor-pointer hover:border-gray duration-100"
				:class="modelValue && '!border-black'"
			>
				<div
					class="w-4 h-4 rounded-full"
					:style="backgroundStyles"
				>

					<input
						type="checkbox"
						class="hidden"
						:checked="modelValue"
						@change="$emit('update:modelValue', ($event.target as any).checked)"
					/>
				</div>
			</div>
		</label>
		<template #popper>
			<span class="text-xs">{{ name }}</span>
		</template>
	</VTooltip>
</template>
